import type { AnnotationT } from '../../../labelling/types/annotations.type';
import type { FrameAnnotationInfo, MetadataPayload } from '../../studio-store/types';
export type AnnotationFrameWriteEntry = {
  frameIndex: number;
  annotationId: string;
  annotation: AnnotationT;
};
export const STUDIO_WRITE_ACTIONS = ({
  WRITE_ANNOTATION: 'WRITE_ANNOTATION',
  BULK_WRITE: 'BULK_WRITE',
  DELETE_ANNOTATION: 'DELETE_ANNOTATION',
  BULK_DELETE: 'BULK_DELETE',
  PROMOTE_TO_KEYFRAME: 'PROMOTE_TO_KEYFRAME',
  UPDATE_METADATA: 'UPDATE_METADATA'
} as const);
export type StudioWriteAction = {
  type: typeof STUDIO_WRITE_ACTIONS.WRITE_ANNOTATION;
  frameIndex: number;
  annotationId: string;
  annotation: AnnotationT;
} | {
  type: typeof STUDIO_WRITE_ACTIONS.BULK_WRITE;
  writes: AnnotationFrameWriteEntry[];
} | {
  type: typeof STUDIO_WRITE_ACTIONS.DELETE_ANNOTATION;
  frameIndex: number;
  annotationId: string;
} | {
  type: typeof STUDIO_WRITE_ACTIONS.BULK_DELETE;
  deletes: FrameAnnotationInfo[];
} | {
  type: typeof STUDIO_WRITE_ACTIONS.PROMOTE_TO_KEYFRAME;
  frameIndex: number;
  annotationId: string;
} | {
  type: typeof STUDIO_WRITE_ACTIONS.UPDATE_METADATA;
  annotationId: string;
  partialPayload: Partial<Omit<MetadataPayload, 'annotationId'>>;
};